import {
  Button,
  Icons,
  Step,
  Stepper,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

import { SCREEN_TO_STEP_INDEX } from '../../_constants';
import { useAutoOptimization } from '../../_hooks/useAutoOptimization';
import { AutoOptimizationScreen } from '../../_types';

const AutoOptimizationStepper = ({ activeStep }: { activeStep: number }) => {
  const { onStepClick, isLoadingScreen } = useAutoOptimization();

  const stepClick = (index: number) =>
    index < activeStep ? () => onStepClick(index) : undefined;

  return (
    <Stepper activeStep={activeStep} size="small" sx={{ minWidth: 800 }}>
      <Step
        label="Features"
        onClick={stepClick(
          SCREEN_TO_STEP_INDEX[AutoOptimizationScreen.Features]
        )}
      />
      <Step
        label="Profile"
        onClick={stepClick(
          SCREEN_TO_STEP_INDEX[AutoOptimizationScreen.Priority]
        )}
      />
      <Step
        label="Scope"
        onClick={stepClick(
          SCREEN_TO_STEP_INDEX[AutoOptimizationScreen.Exclusions]
        )}
      />
      <Step
        label="Review"
        loading={isLoadingScreen}
        onClick={stepClick(
          SCREEN_TO_STEP_INDEX[AutoOptimizationScreen.Recommendations]
        )}
      />
    </Stepper>
  );
};

export const WizardTopBar = () => {
  const { onReset, currentScreen } = useAutoOptimization();
  const activeStep = SCREEN_TO_STEP_INDEX[currentScreen];

  return (
    <Stack
      alignItems="center"
      sx={{
        position: 'relative',
        bgcolor: tokens.theme.bg.structural.surfaceSubtle,
        borderBottom: '1px solid',
        borderColor: tokens.theme.border.structural.neutral,
        px: 32,
        pt: 16,
        pb: 38,
      }}
    >
      <AutoOptimizationStepper activeStep={activeStep} />
      <Box
        sx={{
          position: 'absolute',
          right: 16,
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        <Button
          variant="ghost"
          size="sm"
          onClick={onReset}
          sx={{ minWidth: 0, p: 4 }}
        >
          <Icons.X size={20} />
        </Button>
      </Box>
    </Stack>
  );
};
